import React, { FC } from 'react';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';

import NotificationsRepository from 'src/api/repositories/common/v1/notifications.repository';
import { RootState } from 'src/store/types';

const MAX_UNREAD_COUNT = 99;

export const MessageCenterNotificationsCount: FC = () => {
  const { settings } = useSelector((state: RootState) => state.user);
  const pollingSeconds =
    settings?.unreadCountPollingIntervalSeconds && settings.unreadCountPollingIntervalSeconds > 0
      ? settings.unreadCountPollingIntervalSeconds
      : 60;

  const { data: unreadCount } = NotificationsRepository.endpoints.useGetNotificationsUnreadCountQuery(undefined, {
    pollingInterval: pollingSeconds * 1000,
  });

  if (!unreadCount) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 8,
        background: (theme) => theme.palette.primary.main,
        color: (theme) => theme.palette.primary.contrastText,
        fontSize: '0.625rem',
        lineHeight: 1,
        minWidth: 16,
        padding: 0.25,
        borderRadius: '50%',
        aspectRatio: '1/1',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {unreadCount > MAX_UNREAD_COUNT ? `${MAX_UNREAD_COUNT}+` : unreadCount}
    </Box>
  );
};
